module.exports = __webpack_public_path__ + "static/media/Mr.-10.b90637e6.gif";